/**
 * Limit the value max and min
 * @param {Number} value
 * @param {Number} min
 * @param {Number} max
 */
const limitValue = (value, min = 1, max = 0) => {
  return Math.min(Math.max(value, max), min);
}

export default limitValue;